import api from "../../../services/api";
import { errorFormater } from "../../../services/errorHandler";

const deleteNote = (set) => async (id) => {
  try {
    set({ isLoading: true });
    await api.delete(`/notes/${id}/`);
    set({ isLoading: false });
  } catch (error) {
    set({ isLoading: false });
    throw errorFormater(error.response);
  }
};

export default deleteNote;
